module.exports = __webpack_public_path__ + "static/media/logo-footer.ca5019c7.svg";